import { useContext, useMemo } from 'react';
import { ChannelFormContext } from '../ChannelForm.context';
import { useGetChannelsBudgetQuery, useGetRateCardOptionsQuery } from '@/api';
import { UseChannelOptions, OptionsSearchParams } from '../ChannelForm.types';
import { buildRateCardOptionsQueryParams } from '../../../utils/rateCardLookup';

export const useChannelOptions: UseChannelOptions = (searchParams?: OptionsSearchParams) => {
  const {
    mediaPlanId,
    totalBudget,
    channel: contextChannel,
    kpi: contextKpi,
    formats: contextFormats,
    product: contextProduct,
    rateSource,
    _id: excludeChannel
  } = useContext(ChannelFormContext);

  const channel = searchParams?.channel ?? contextChannel;
  const kpi = searchParams?.kpi ?? contextKpi;
  const formats = searchParams?.formats ?? contextFormats;
  const product = searchParams?.product ?? contextProduct;

  const budgetArgs = excludeChannel ? { mediaPlanId, excludeChannel } : { mediaPlanId };

  const { data: channelsBudget } = useGetChannelsBudgetQuery(budgetArgs, { skip: !mediaPlanId });

  const rateCardQueryParams = useMemo(
    () =>
      buildRateCardOptionsQueryParams({
        channel,
        product,
        kpi,
        formats,
        rateSource,
        showDraft: true
      }),
    [channel, product, kpi, formats, rateSource]
  );

  const { data: options, isLoading: areOptionsLoading } = useGetRateCardOptionsQuery(
    (rateCardQueryParams ?? { showDraft: true }) as Parameters<typeof useGetRateCardOptionsQuery>[0],
    {
      skip: rateCardQueryParams === null,
      refetchOnMountOrArgChange: true
    }
  );

  return {
    channel,
    totalBudget,
    channelsBudget,
    options,
    areOptionsLoading
  };
};
